import { CustomerMyBasePayTeamModel } from 'api/backofficeApiClient';

import { ClientCreationEnum } from './enum';

export type MyBasePayTeamUserIds = {
  mbpClientSuccessPartnerUserId?: string;
  mbpBillingRepresentativeUserId?: string;
  mspSalesRepresentativeUserId?: string;
  mbpCollectionsRepresentativeUserId?: string;
  mspWorkforceSpecialistUserId?: string;
};

export const getIsMyBasePayTeamSectionVisible = (
  creationType: ClientCreationEnum,
  isAdmin: boolean,
): boolean =>
  creationType === ClientCreationEnum.Edit && isAdmin;

const toMyBasePayTeamPayload = (
  values: MyBasePayTeamUserIds,
): CustomerMyBasePayTeamModel => ({
  mbpClientSuccessPartnerUserId:
    values.mbpClientSuccessPartnerUserId || undefined,
  mbpBillingRepresentativeUserId:
    values.mbpBillingRepresentativeUserId || undefined,
  mspSalesRepresentativeUserId: values.mspSalesRepresentativeUserId || undefined,
  mbpCollectionsRepresentativeUserId:
    values.mbpCollectionsRepresentativeUserId || undefined,
  mspWorkforceSpecialistUserId:
    values.mspWorkforceSpecialistUserId || undefined,
});

export const buildMyBasePayTeamForRequest = (
  creationType: ClientCreationEnum,
  formValues: MyBasePayTeamUserIds,
): CustomerMyBasePayTeamModel | undefined => {
  if (creationType !== ClientCreationEnum.Edit) {
    return undefined;
  }

  return toMyBasePayTeamPayload(formValues);
};
